import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../../../../Color.js";
import { toLCH as e, toRGB as r, toLAB as s } from "../../../../../core/colorUtils.js";
import { unitBezier as n } from "../../../unitBezier.js";
import { interpolate as a } from "../GeometryUtils.js";
import { ValueType as o, StringType as i, ObjectType as l, NumberType as u, BooleanType as c, ColorType as h, typeToString as p, arrayType as g, getType as f, matchType as w, valueToString as m } from "./types.js";

var y = /*#__PURE__*/function () {
  function y(t) {
    _classCallCheck(this, y);

    this.parent = t, this.vars = {};
  }

  _createClass(y, [{
    key: "add",
    value: function add(t, e) {
      this.vars[t] = e;
    }
  }, {
    key: "get",
    value: function get(t) {
      return this.vars[t] ? this.vars[t] : this.parent ? this.parent.get(t) : null;
    }
  }]);

  return y;
}();

var v = /*#__PURE__*/function () {
  function v() {
    _classCallCheck(this, v);

    this.type = o;
  }

  _createClass(v, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return null == t ? void 0 : t.id;
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      if (t.length > 1) throw new Error('"id" does not expect arguments');
      return new v();
    }
  }]);

  return v;
}();

var b = /*#__PURE__*/function () {
  function b() {
    _classCallCheck(this, b);

    this.type = i;
  }

  _createClass(b, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      if (!t) return null;

      switch (t.type) {
        case 1:
          return "Point";

        case 2:
          return "LineString";

        case 3:
          return "Polygon";

        default:
          return null;
      }
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      if (t.length > 1) throw new Error('"geometry-type" does not expect arguments');
      return new b();
    }
  }]);

  return b;
}();

var d = /*#__PURE__*/function () {
  function d() {
    _classCallCheck(this, d);

    this.type = l;
  }

  _createClass(d, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return null == t ? void 0 : t.values;
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      if (t.length > 1) throw new Error('"properties" does not expect arguments');
      return new d();
    }
  }]);

  return d;
}();

var x = /*#__PURE__*/function () {
  function x() {
    _classCallCheck(this, x);

    this.type = u;
  }

  _createClass(x, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return e;
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      if (t.length > 1) throw new Error('"zoom" does not expect arguments');
      return new x();
    }
  }]);

  return x;
}();

var E = /*#__PURE__*/function () {
  function E(t, e, r) {
    _classCallCheck(this, E);

    this.lhs = t, this.rhs = e, this.compare = r, this.type = c;
  }

  _createClass(E, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return this.compare(this.lhs.evaluate(t, e), this.rhs.evaluate(t, e));
    }
  }], [{
    key: "parse",
    value: function parse(t, e, r) {
      if (3 !== t.length && 4 !== t.length) throw new Error("\"".concat(t[0], "\" expects 2 or 3 arguments"));
      if (4 === t.length) throw new Error("\"".concat(t[0], "\" collator not supported"));
      return new E(ht(t[1], e), ht(t[2], e), r);
    }
  }]);

  return E;
}();

var $ = /*#__PURE__*/function (_E) {
  _inherits($, _E);

  var _super = _createSuper($);

  function $() {
    _classCallCheck(this, $);

    return _super.apply(this, arguments);
  }

  _createClass($, null, [{
    key: "parse",
    value: function parse(t, e) {
      return E.parse(t, e, function (t, e) {
        return t === e;
      });
    }
  }]);

  return $;
}(E);

var M = /*#__PURE__*/function (_E2) {
  _inherits(M, _E2);

  var _super2 = _createSuper(M);

  function M() {
    _classCallCheck(this, M);

    return _super2.apply(this, arguments);
  }

  _createClass(M, null, [{
    key: "parse",
    value: function parse(t, e) {
      return E.parse(t, e, function (t, e) {
        return t !== e;
      });
    }
  }]);

  return M;
}(E);

var k = /*#__PURE__*/function (_E3) {
  _inherits(k, _E3);

  var _super3 = _createSuper(k);

  function k() {
    _classCallCheck(this, k);

    return _super3.apply(this, arguments);
  }

  _createClass(k, null, [{
    key: "parse",
    value: function parse(t, e) {
      return E.parse(t, e, function (t, e) {
        return t < e;
      });
    }
  }]);

  return k;
}(E);

var A = /*#__PURE__*/function (_E4) {
  _inherits(A, _E4);

  var _super4 = _createSuper(A);

  function A() {
    _classCallCheck(this, A);

    return _super4.apply(this, arguments);
  }

  _createClass(A, null, [{
    key: "parse",
    value: function parse(t, e) {
      return E.parse(t, e, function (t, e) {
        return t <= e;
      });
    }
  }]);

  return A;
}(E);

var j = /*#__PURE__*/function (_E5) {
  _inherits(j, _E5);

  var _super5 = _createSuper(j);

  function j() {
    _classCallCheck(this, j);

    return _super5.apply(this, arguments);
  }

  _createClass(j, null, [{
    key: "parse",
    value: function parse(t, e) {
      return E.parse(t, e, function (t, e) {
        return t > e;
      });
    }
  }]);

  return j;
}(E);

var q = /*#__PURE__*/function (_E6) {
  _inherits(q, _E6);

  var _super6 = _createSuper(q);

  function q() {
    _classCallCheck(this, q);

    return _super6.apply(this, arguments);
  }

  _createClass(q, null, [{
    key: "parse",
    value: function parse(t, e) {
      return E.parse(t, e, function (t, e) {
        return t >= e;
      });
    }
  }]);

  return q;
}(E);

var N = /*#__PURE__*/function () {
  function N(t) {
    _classCallCheck(this, N);

    this.arg = t, this.type = c;
  }

  _createClass(N, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return !this.arg.evaluate(t, e);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (2 !== t.length) throw new Error('"!" expects 1 argument');
      return new N(ht(t[1], e));
    }
  }]);

  return N;
}();

var _ = /*#__PURE__*/function () {
  function _(t) {
    _classCallCheck(this, _);

    this.args = t, this.type = c;
  }

  _createClass(_, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var _iterator = _createForOfIteratorHelper(this.args),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _r = _step.value;
          if (!_r.evaluate(t, e)) return !1;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return !0;
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r = [];

      for (var _s = 1; _s < t.length; _s++) {
        r.push(ht(t[_s], e));
      }

      return new _(r);
    }
  }]);

  return _;
}();

var R = /*#__PURE__*/function () {
  function R(t) {
    _classCallCheck(this, R);

    this.args = t, this.type = c;
  }

  _createClass(R, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var _iterator2 = _createForOfIteratorHelper(this.args),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _r2 = _step2.value;
          if (_r2.evaluate(t, e)) return !0;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return !1;
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r = [];

      for (var _s2 = 1; _s2 < t.length; _s2++) {
        r.push(ht(t[_s2], e));
      }

      return new R(r);
    }
  }]);

  return R;
}();

var C = /*#__PURE__*/function () {
  function C(t) {
    _classCallCheck(this, C);

    this.args = t, this.type = c;
  }

  _createClass(C, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var _iterator3 = _createForOfIteratorHelper(this.args),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _r3 = _step3.value;
          if (_r3.evaluate(t, e)) return !1;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return !0;
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r = [];

      for (var _s3 = 1; _s3 < t.length; _s3++) {
        r.push(ht(t[_s3], e));
      }

      return new C(r);
    }
  }]);

  return C;
}();

var z = /*#__PURE__*/function () {
  function z(t, e, r) {
    _classCallCheck(this, z);

    this.type = t, this.args = e, this.fallback = r;
  }

  _createClass(z, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var _iterator4 = _createForOfIteratorHelper(this.args),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _r4 = _step4.value;
          if (_r4.condition.evaluate(t, e)) return _r4.output.evaluate(t, e);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return this.fallback.evaluate(t, e);
    }
  }], [{
    key: "parse",
    value: function parse(t, e, r) {
      if (t.length < 4) throw new Error('"case" expects at least 3 arguments');
      if (t.length % 2 == 1) throw new Error('"case" expects an odd number of arguments');
      var s;
      var n = [];

      for (var _o = 1; _o < t.length - 1; _o += 2) {
        var _a = ht(t[_o], e),
            _i = ht(t[_o + 1], e, r);

        s || (s = _i.type), n.push({
          condition: _a,
          output: _i
        });
      }

      var a = ht(t[t.length - 1], e, r);
      return s || (s = a.type), new z(s, n, a);
    }
  }]);

  return z;
}();

var I = /*#__PURE__*/function () {
  function I(t, e) {
    _classCallCheck(this, I);

    this.type = t, this.args = e;
  }

  _createClass(I, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var _iterator5 = _createForOfIteratorHelper(this.args),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _r5 = _step5.value;

          var _s4 = _r5.evaluate(t, e);

          if (null !== _s4) return _s4;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return null;
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (t.length < 2) throw new Error('"coalesce" expects at least 1 argument');
      var r;
      var s = [];

      for (var _n = 1; _n < t.length; _n++) {
        var _a2 = ht(t[_n], e);

        r || (r = _a2.type), s.push(_a2);
      }

      return new I(r, s);
    }
  }]);

  return I;
}();

var L = /*#__PURE__*/function () {
  function L(t, e, r, s, n) {
    _classCallCheck(this, L);

    this.type = t, this.input = e, this.labels = r, this.outputs = s, this.fallback = n;
  }

  _createClass(L, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.input.evaluate(t, e);
      return (this.outputs[this.labels[r]] || this.fallback).evaluate(t, e);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (t.length < 3) throw new Error('"match" expects at least 3 arguments');
      if (t.length % 2 == 0) throw new Error('"case" expects an even number of arguments');
      var r;
      var s = ht(t[1], e),
          n = [],
          a = {};
      var o;

      for (var _i2 = 2; _i2 < t.length - 1; _i2 += 2) {
        var _s5 = t[_i2];
        Array.isArray(_s5) || (_s5 = [_s5]);

        var _iterator6 = _createForOfIteratorHelper(_s5),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _t = _step6.value;

            var _e = typeof _t;

            if ("string" !== _e && "number" !== _e) throw new Error('"match" requires string or number literal as labels');

            if (o) {
              if (_e !== o) throw new Error('"match" requires labels to have the same type');
            } else o = _e;

            a[_t] = n.length;
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        var _l = ht(t[_i2 + 1], e);

        r || (r = _l.type), n.push(_l);
      }

      return new L(r, s, a, n, ht(t[t.length - 1], e));
    }
  }]);

  return L;
}();

var U = /*#__PURE__*/function () {
  function U(t, e, r, s, n) {
    _classCallCheck(this, U);

    this.operator = t, this.type = e, this.interpolation = r, this.input = s, this.stops = n;
  }

  _createClass(U, [{
    key: "evaluate",
    value: function evaluate(n, o) {
      var i = this.stops;
      if (1 === i.length) return i[0][1].evaluate(n, o);
      var l = this.input.evaluate(n, o);
      if (l <= i[0][0]) return i[0][1].evaluate(n, o);
      if (l >= i[i.length - 1][0]) return i[i.length - 1][1].evaluate(n, o);
      var u = 0;

      for (; ++u < i.length && !(l < i[u][0]);) {
        ;
      }

      var c = i[u - 1][0],
          h = i[u][0],
          g = U.interpolationRatio(this.interpolation, l, c, h),
          f = i[u - 1][1].evaluate(n, o),
          w = i[u][1].evaluate(n, o);

      if ("interpolate" === this.operator) {
        if ("array" === this.type.kind && Array.isArray(f) && Array.isArray(w)) return f.map(function (t, e) {
          return a(t, w[e], g);
        });

        if ("color" === this.type.kind && f instanceof t && w instanceof t) {
          var _e2 = new t(f),
              _r6 = new t(w);

          return new t([a(_e2.r, _r6.r, g), a(_e2.g, _r6.g, g), a(_e2.b, _r6.b, g), a(_e2.a, _r6.a, g)]);
        }

        if ("number" === this.type.kind && "number" == typeof f && "number" == typeof w) return a(f, w, g);
        throw new Error("\"".concat(this.operator, "\" cannot interpolate type ").concat(p(this.type)));
      }

      if ("interpolate-hcl" === this.operator) {
        var _s6 = e(f),
            _n2 = e(w),
            _o2 = _n2.h - _s6.h,
            _i3 = r({
          h: _s6.h + g * (_o2 > 180 || _o2 < -180 ? _o2 - 360 * Math.round(_o2 / 360) : _o2),
          c: a(_s6.c, _n2.c, g),
          l: a(_s6.l, _n2.l, g)
        });

        return new t(_objectSpread({
          a: a(f.a, w.a, g)
        }, _i3));
      }

      if ("interpolate-lab" === this.operator) {
        var _e3 = s(f),
            _n3 = s(w),
            _o3 = r({
          l: a(_e3.l, _n3.l, g),
          a: a(_e3.a, _n3.a, g),
          b: a(_e3.b, _n3.b, g)
        });

        return new t(_objectSpread({
          a: a(f.a, w.a, g)
        }, _o3));
      }

      throw new Error("Unexpected operator \"".concat(this.operator, "\""));
    }
  }, {
    key: "interpolationUniformValue",
    value: function interpolationUniformValue(t, e) {
      var r = this.stops;
      if (1 === r.length) return 0;
      if (t >= r[r.length - 1][0]) return 0;
      var s = 0;

      for (; ++s < r.length && !(t < r[s][0]);) {
        ;
      }

      var n = r[s - 1][0],
          a = r[s][0];
      return U.interpolationRatio(this.interpolation, e, n, a);
    }
  }, {
    key: "getInterpolationRange",
    value: function getInterpolationRange(t) {
      var e = this.stops;

      if (1 === e.length) {
        var _t2 = e[0][0];
        return [_t2, _t2];
      }

      var r = e[e.length - 1][0];
      if (t >= r) return [r, r];
      var s = 0;

      for (; ++s < e.length && !(t < e[s][0]);) {
        ;
      }

      return [e[s - 1][0], e[s][0]];
    }
  }], [{
    key: "parse",
    value: function parse(t, e, r) {
      var s = t[0];
      if (t.length < 5) throw new Error("\"".concat(s, "\" expects at least 4 arguments"));
      var n = t[1];
      if (!Array.isArray(n) || 0 === n.length) throw new Error("\"".concat(n, "\" is not a valid interpolation"));

      switch (n[0]) {
        case "linear":
          if (1 !== n.length) throw new Error("Linear interpolation cannot have parameters");
          break;

        case "exponential":
          if (2 !== n.length || "number" != typeof n[1]) throw new Error("Exponential interpolation requires one numeric argument");
          break;

        case "cubic-bezier":
          if (5 !== n.length) throw new Error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1");

          for (var _t3 = 1; _t3 < 5; _t3++) {
            var _e4 = n[_t3];
            if ("number" != typeof _e4 || _e4 < 0 || _e4 > 1) throw new Error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1");
          }

          break;

        default:
          throw new Error("\"".concat(t[0], "\" unknown interpolation type \"").concat(n[0], "\""));
      }

      if (t.length % 2 != 1) throw new Error("\"".concat(s, "\" expects an even number of arguments"));
      var a = ht(t[2], e, u);
      var o;
      "interpolate-hcl" === s || "interpolate-lab" === s ? o = h : r && "value" !== r.kind && (o = r);
      var i = [];

      for (var _l2 = 3; _l2 < t.length; _l2 += 2) {
        var _r7 = t[_l2];
        if ("number" != typeof _r7) throw new Error("\"".concat(s, "\" requires stop inputs as literal numbers"));
        if (i.length && i[i.length - 1][0] >= _r7) throw new Error("\"".concat(s, "\" requires strictly ascending stop inputs"));

        var _n4 = ht(t[_l2 + 1], e, o);

        o || (o = _n4.type), i.push([_r7, _n4]);
      }

      if (o && o !== h && o !== u && ("array" !== o.kind || o.itemType !== u)) throw new Error("\"".concat(s, "\" cannot interpolate type ").concat(p(o)));
      return new U(s, o, n, a, i);
    }
  }, {
    key: "interpolationRatio",
    value: function interpolationRatio(t, e, r, s) {
      var a = 0;
      if ("linear" === t[0]) a = U.exponentialInterpolationRatio(e, 1, r, s);else if ("exponential" === t[0]) a = U.exponentialInterpolationRatio(e, t[1], r, s);else if ("cubic-bezier" === t[0]) {
        a = n(t[1], t[2], t[3], t[4])(U.exponentialInterpolationRatio(e, 1, r, s), 1e-5);
      }
      return a < 0 ? a = 0 : a > 1 && (a = 1), a;
    }
  }, {
    key: "exponentialInterpolationRatio",
    value: function exponentialInterpolationRatio(t, e, r, s) {
      var n = s - r;
      if (0 === n) return 0;
      var a = t - r;
      return 1 === e ? a / n : (Math.pow(e, a) - 1) / (Math.pow(e, n) - 1);
    }
  }]);

  return U;
}();

var B = /*#__PURE__*/function () {
  function B(t, e, r) {
    _classCallCheck(this, B);

    this.type = t, this.input = e, this.stops = r;
  }

  _createClass(B, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.stops;
      if (1 === r.length) return r[0][1].evaluate(t, e);
      var s = this.input.evaluate(t, e);
      var n = 0;

      for (; ++n < r.length && !(s < r[n][0]);) {
        ;
      }

      return this.stops[n - 1][1].evaluate(t, e);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (t.length < 5) throw new Error('"step" expects at least 4 arguments');
      if (t.length % 2 != 1) throw new Error('"step" expects an even number of arguments');
      var r = ht(t[1], e, u);
      var s;
      var n = [];
      n.push([-1 / 0, ht(t[2], e)]);

      for (var _a3 = 3; _a3 < t.length; _a3 += 2) {
        var _r8 = t[_a3];
        if ("number" != typeof _r8) throw new Error('"step" requires stop inputs as literal numbers');
        if (n.length && n[n.length - 1][0] >= _r8) throw new Error('"step" requires strictly ascending stop inputs');

        var _o4 = ht(t[_a3 + 1], e);

        s || (s = _o4.type), n.push([_r8, _o4]);
      }

      return new B(s, r, n);
    }
  }]);

  return B;
}();

var S = /*#__PURE__*/function () {
  function S(t, e) {
    _classCallCheck(this, S);

    this.type = t, this.output = e;
  }

  _createClass(S, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return this.output.evaluate(t, e);
    }
  }], [{
    key: "parse",
    value: function parse(t, e, r) {
      if (t.length < 4) throw new Error('"let" expects at least 3 arguments');
      if (t.length % 2 == 1) throw new Error('"let" expects an odd number of arguments');
      var s = new y(e);

      for (var _a4 = 1; _a4 < t.length - 1; _a4 += 2) {
        var _r9 = t[_a4];
        if ("string" != typeof _r9) throw new Error("\"let\" requires a string to define variable names - found ".concat(_r9));
        s.add(_r9, ht(t[_a4 + 1], e));
      }

      var n = ht(t[t.length - 1], s, r);
      return new S(n.type, n);
    }
  }]);

  return S;
}();

var O = /*#__PURE__*/function () {
  function O(t, e) {
    _classCallCheck(this, O);

    this.type = t, this.output = e;
  }

  _createClass(O, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return this.output.evaluate(t, e);
    }
  }], [{
    key: "parse",
    value: function parse(t, e, r) {
      if (2 !== t.length || "string" != typeof t[1]) throw new Error('"var" requires just one literal string argument');
      var s = e.get(t[1]);
      if (!s) throw new Error("".concat(t[1], " must be defined before being used in a \"var\" expression"));
      return new O(r || o, s);
    }
  }]);

  return O;
}();

var P = /*#__PURE__*/function () {
  function P(t, e, r) {
    _classCallCheck(this, P);

    this.type = t, this.index = e, this.array = r;
  }

  _createClass(P, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.index.evaluate(t, e),
          s = this.array.evaluate(t, e);
      if (r < 0 || r >= s.length) throw new Error('"at" index out of bounds');
      if (r !== Math.floor(r)) throw new Error('"at" index must be an integer');
      return s[r];
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (3 !== t.length) throw new Error('"at" expects 2 arguments');
      var r = ht(t[1], e, u),
          s = ht(t[2], e);
      return new P(s.type.itemType, r, s);
    }
  }]);

  return P;
}();

var T = /*#__PURE__*/function () {
  function T(t, e) {
    _classCallCheck(this, T);

    this.key = t, this.obj = e, this.type = o;
  }

  _createClass(T, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.key.evaluate(t, e);

      if (this.obj) {
        return this.obj.evaluate(t, e)[r];
      }

      return null == t ? void 0 : t.values[r];
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r, s;

      switch (t.length) {
        case 2:
          return r = ht(t[1], e), new T(r);

        case 3:
          return r = ht(t[1], e), s = ht(t[2], e), new T(r, s);

        default:
          throw new Error('"get" expects 1 or 2 arguments');
      }
    }
  }]);

  return T;
}();

var F = /*#__PURE__*/function () {
  function F(t, e) {
    _classCallCheck(this, F);

    this.key = t, this.obj = e, this.type = c;
  }

  _createClass(F, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.key.evaluate(t, e);

      if (this.obj) {
        return r in this.obj.evaluate(t, e);
      }

      return !(null == t || !t.values[r]);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r, s;

      switch (t.length) {
        case 2:
          return r = ht(t[1], e), new F(r);

        case 3:
          return r = ht(t[1], e), s = ht(t[2], e), new F(r, s);

        default:
          throw new Error('"has" expects 1 or 2 arguments');
      }
    }
  }]);

  return F;
}();

var G = /*#__PURE__*/function () {
  function G(t, e) {
    _classCallCheck(this, G);

    this.key = t, this.vals = e, this.type = c;
  }

  _createClass(G, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.key.evaluate(t, e);
      return -1 !== this.vals.evaluate(t, e).indexOf(r);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (3 !== t.length) throw new Error('"in" expects 2 arguments');
      return new G(ht(t[1], e), ht(t[2], e));
    }
  }]);

  return G;
}();

var V = /*#__PURE__*/function () {
  function V(t, e, r) {
    _classCallCheck(this, V);

    this.item = t, this.array = e, this.from = r, this.type = u;
  }

  _createClass(V, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.item.evaluate(t, e),
          s = this.array.evaluate(t, e);

      if (this.from) {
        var _n5 = this.from.evaluate(t, e);

        if (_n5 !== Math.floor(_n5)) throw new Error('"index-of" index must be an integer');
        return s.indexOf(r, _n5);
      }

      return s.indexOf(r);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (t.length < 3 || t.length > 4) throw new Error('"index-of" expects 3 or 4 arguments');
      var r = ht(t[1], e),
          s = ht(t[2], e);

      if (4 === t.length) {
        var _n6 = ht(t[3], e, u);

        return new V(r, s, _n6);
      }

      return new V(r, s);
    }
  }]);

  return V;
}();

var D = /*#__PURE__*/function () {
  function D(t) {
    _classCallCheck(this, D);

    this.arg = t, this.type = u;
  }

  _createClass(D, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.arg.evaluate(t, e);
      if ("string" == typeof r) return r.length;
      if (Array.isArray(r)) return r.length;
      throw new Error('"length" expects string or array');
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (2 !== t.length) throw new Error('"length" expects 2 arguments');
      var r = ht(t[1], e);
      return new D(r);
    }
  }]);

  return D;
}();

var H = /*#__PURE__*/function () {
  function H(t, e, r, s) {
    _classCallCheck(this, H);

    this.type = t, this.array = e, this.from = r, this.to = s;
  }

  _createClass(H, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r = this.array.evaluate(t, e);
      if (!Array.isArray(r) && "string" != typeof r) throw new Error('"slice" input must be an array or a string');
      var s = this.from.evaluate(t, e);
      if (s < 0 || s >= r.length) throw new Error('"slice" index out of bounds');
      if (s !== Math.floor(s)) throw new Error('"slice" index must be an integer');

      if (this.to) {
        var _n7 = this.to.evaluate(t, e);

        if (_n7 < 0 || _n7 >= r.length) throw new Error('"slice" index out of bounds');
        if (_n7 !== Math.floor(_n7)) throw new Error('"slice" index must be an integer');
        return r.slice(s, _n7);
      }

      return r.slice(s);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (t.length < 3 || t.length > 4) throw new Error('"slice" expects 2 or 3 arguments');
      var r = ht(t[1], e),
          s = ht(t[2], e, u);
      if (s.type !== u) throw new Error('"slice" index must return a number');

      if (4 === t.length) {
        var _n8 = ht(t[3], e, u);

        if (_n8.type !== u) throw new Error('"slice" index must return a number');
        return new H(r.type, r, s, _n8);
      }

      return new H(r.type, r, s);
    }
  }]);

  return H;
}();

var J = /*#__PURE__*/function () {
  function J() {
    _classCallCheck(this, J);

    this.type = c;
  }

  _createClass(J, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return t && void 0 !== t.id;
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      if (1 !== t.length) throw new Error('"has-id" expects no arguments');
      return new J();
    }
  }]);

  return J;
}();

var K = /*#__PURE__*/function () {
  function K(t, e) {
    _classCallCheck(this, K);

    this.args = t, this.calculate = e, this.type = u;
  }

  _createClass(K, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r;
      return this.args && (r = this.args.map(function (r) {
        return r.evaluate(t, e);
      })), this.calculate(r);
    }
  }], [{
    key: "parse",
    value: function parse(t, e, r) {
      var s = t.slice(1).map(function (t) {
        return ht(t, e);
      });
      return new K(s, r);
    }
  }]);

  return K;
}();

var Q = /*#__PURE__*/function (_K) {
  _inherits(Q, _K);

  var _super7 = _createSuper(Q);

  function Q() {
    _classCallCheck(this, Q);

    return _super7.apply(this, arguments);
  }

  _createClass(Q, null, [{
    key: "parse",
    value: function parse(t, e) {
      switch (t.length) {
        case 2:
          return K.parse(t, e, function (t) {
            return -t[0];
          });

        case 3:
          return K.parse(t, e, function (t) {
            return t[0] - t[1];
          });

        default:
          throw new Error('"-" expects 1 or 2 arguments');
      }
    }
  }]);

  return Q;
}(K);

var W = /*#__PURE__*/function (_K2) {
  _inherits(W, _K2);

  var _super8 = _createSuper(W);

  function W() {
    _classCallCheck(this, W);

    return _super8.apply(this, arguments);
  }

  _createClass(W, null, [{
    key: "parse",
    value: function parse(t, e) {
      return K.parse(t, e, function (t) {
        var e = 1;

        var _iterator7 = _createForOfIteratorHelper(t),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _r10 = _step7.value;
            e *= _r10;
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        return e;
      });
    }
  }]);

  return W;
}(K);

var X = /*#__PURE__*/function (_K3) {
  _inherits(X, _K3);

  var _super9 = _createSuper(X);

  function X() {
    _classCallCheck(this, X);

    return _super9.apply(this, arguments);
  }

  _createClass(X, null, [{
    key: "parse",
    value: function parse(t, e) {
      if (3 === t.length) return K.parse(t, e, function (t) {
        return t[0] / t[1];
      });
      throw new Error('"/" expects 2 arguments');
    }
  }]);

  return X;
}(K);

var Y = /*#__PURE__*/function (_K4) {
  _inherits(Y, _K4);

  var _super10 = _createSuper(Y);

  function Y() {
    _classCallCheck(this, Y);

    return _super10.apply(this, arguments);
  }

  _createClass(Y, null, [{
    key: "parse",
    value: function parse(t, e) {
      if (3 === t.length) return K.parse(t, e, function (t) {
        return t[0] % t[1];
      });
      throw new Error('"%" expects 2 arguments');
    }
  }]);

  return Y;
}(K);

var Z = /*#__PURE__*/function (_K5) {
  _inherits(Z, _K5);

  var _super11 = _createSuper(Z);

  function Z() {
    _classCallCheck(this, Z);

    return _super11.apply(this, arguments);
  }

  _createClass(Z, null, [{
    key: "parse",
    value: function parse(t, e) {
      if (3 === t.length) return K.parse(t, e, function (t) {
        return Math.pow(t[0], t[1]);
      });
      throw new Error('"^" expects 1 or 2 arguments');
    }
  }]);

  return Z;
}(K);

var tt = /*#__PURE__*/function (_K6) {
  _inherits(tt, _K6);

  var _super12 = _createSuper(tt);

  function tt() {
    _classCallCheck(this, tt);

    return _super12.apply(this, arguments);
  }

  _createClass(tt, null, [{
    key: "parse",
    value: function parse(t, e) {
      return K.parse(t, e, function (t) {
        var e = 0;

        var _iterator8 = _createForOfIteratorHelper(t),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _r11 = _step8.value;
            e += _r11;
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return e;
      });
    }
  }]);

  return tt;
}(K);

var et = /*#__PURE__*/function () {
  function et(t, e) {
    _classCallCheck(this, et);

    this.args = t, this.calculate = e, this.type = u;
  }

  _createClass(et, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r;
      return this.args && (r = this.args.map(function (r) {
        return r.evaluate(t, e);
      })), this.calculate(r);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r = t.slice(1).map(function (t) {
        return ht(t, e);
      });
      return new et(r, et.ops[t[0]]);
    }
  }]);

  return et;
}();

et.ops = {
  abs: function abs(t) {
    return Math.abs(t[0]);
  },
  acos: function acos(t) {
    return Math.acos(t[0]);
  },
  asin: function asin(t) {
    return Math.asin(t[0]);
  },
  atan: function atan(t) {
    return Math.atan(t[0]);
  },
  ceil: function ceil(t) {
    return Math.ceil(t[0]);
  },
  cos: function cos(t) {
    return Math.cos(t[0]);
  },
  e: function e() {
    return Math.E;
  },
  floor: function floor(t) {
    return Math.floor(t[0]);
  },
  ln: function ln(t) {
    return Math.log(t[0]);
  },
  ln2: function ln2() {
    return Math.LN2;
  },
  log10: function log10(t) {
    return Math.log(t[0]) / Math.LN10;
  },
  log2: function log2(t) {
    return Math.log(t[0]) / Math.LN2;
  },
  max: function max(t) {
    return Math.max.apply(Math, _toConsumableArray(t));
  },
  min: function min(t) {
    return Math.min.apply(Math, _toConsumableArray(t));
  },
  pi: function pi() {
    return Math.PI;
  },
  round: function round(t) {
    return Math.round(t[0]);
  },
  sin: function sin(t) {
    return Math.sin(t[0]);
  },
  sqrt: function sqrt(t) {
    return Math.sqrt(t[0]);
  },
  tan: function tan(t) {
    return Math.tan(t[0]);
  }
};

var rt = /*#__PURE__*/function () {
  function rt(t) {
    _classCallCheck(this, rt);

    this.args = t, this.type = i;
  }

  _createClass(rt, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return this.args.map(function (r) {
        return r.evaluate(t, e);
      }).join("");
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      return new rt(t.slice(1).map(function (t) {
        return ht(t, e);
      }));
    }
  }]);

  return rt;
}();

var st = /*#__PURE__*/function () {
  function st(t, e) {
    _classCallCheck(this, st);

    this.arg = t, this.calculate = e, this.type = i;
  }

  _createClass(st, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return this.calculate(this.arg.evaluate(t, e));
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (2 !== t.length) throw new Error("".concat(t[0], " expects 1 argument"));
      var r = ht(t[1], e);
      return new st(r, st.ops[t[0]]);
    }
  }]);

  return st;
}();

st.ops = {
  downcase: function downcase(t) {
    return t.toLowerCase();
  },
  upcase: function upcase(t) {
    return t.toUpperCase();
  }
};

var nt = /*#__PURE__*/function () {
  function nt(t) {
    _classCallCheck(this, nt);

    this.args = t, this.type = h;
  }

  _createClass(nt, [{
    key: "evaluate",
    value: function evaluate(e, r) {
      var s = this._validate(this.args[0].evaluate(e, r)),
          n = this._validate(this.args[1].evaluate(e, r)),
          a = this._validate(this.args[2].evaluate(e, r));

      return new t({
        r: s,
        g: n,
        b: a
      });
    }
  }, {
    key: "_validate",
    value: function _validate(t) {
      if ("number" != typeof t || t < 0 || t > 255) throw new Error("".concat(t, ": invalid color component"));
      return Math.round(t);
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (4 !== t.length) throw new Error('"rgb" expects 3 arguments');
      var r = t.slice(1).map(function (t) {
        return ht(t, e);
      });
      return new nt(r);
    }
  }]);

  return nt;
}();

var at = /*#__PURE__*/function () {
  function at(t) {
    _classCallCheck(this, at);

    this.args = t, this.type = h;
  }

  _createClass(at, [{
    key: "evaluate",
    value: function evaluate(e, r) {
      var s = this._validate(this.args[0].evaluate(e, r)),
          n = this._validate(this.args[1].evaluate(e, r)),
          a = this._validate(this.args[2].evaluate(e, r)),
          o = this._validateAlpha(this.args[3].evaluate(e, r));

      return new t({
        r: s,
        g: n,
        b: a,
        a: o
      });
    }
  }, {
    key: "_validate",
    value: function _validate(t) {
      if ("number" != typeof t || t < 0 || t > 255) throw new Error("".concat(t, ": invalid color component"));
      return Math.round(t);
    }
  }, {
    key: "_validateAlpha",
    value: function _validateAlpha(t) {
      if ("number" != typeof t || t < 0 || t > 1) throw new Error("".concat(t, ": invalid alpha color component"));
      return t;
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (5 !== t.length) throw new Error('"rgba" expects 4 arguments');
      var r = t.slice(1).map(function (t) {
        return ht(t, e);
      });
      return new at(r);
    }
  }]);

  return at;
}();

var ot = /*#__PURE__*/function () {
  function ot(t) {
    _classCallCheck(this, ot);

    this.color = t, this.type = g(u, 4);
  }

  _createClass(ot, [{
    key: "evaluate",
    value: function evaluate(e, r) {
      return new t(this.color.evaluate(e, r)).toRgba();
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (2 !== t.length) throw new Error('"to-rgba" expects 1 argument');
      var r = ht(t[1], e);
      return new ot(r);
    }
  }]);

  return ot;
}();

var it = /*#__PURE__*/function () {
  function it(t, e) {
    _classCallCheck(this, it);

    this.type = t, this.args = e;
  }

  _createClass(it, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      var r;

      var _iterator9 = _createForOfIteratorHelper(this.args),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _s7 = _step9.value;

          var _n9 = _s7.evaluate(t, e);

          if (r = f(_n9), w(r, this.type)) return _n9;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      throw new Error("Expected ".concat(p(this.type), " but got ").concat(p(r)));
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r = t[0];
      if (t.length < 2) throw new Error("".concat(r, " expects at least one argument"));
      var s,
          n = 1;

      if ("array" === r) {
        if (t.length > 2) {
          switch (t[1]) {
            case "string":
              s = i;
              break;

            case "number":
              s = u;
              break;

            case "boolean":
              s = c;
              break;

            default:
              throw new Error('"array" type argument must be string, number or boolean');
          }

          n++;
        } else s = o;

        var _e5;

        if (t.length > 3) {
          if (_e5 = t[2], null !== _e5 && ("number" != typeof _e5 || _e5 < 0 || _e5 !== Math.floor(_e5))) throw new Error('"array" length argument must be a positive integer literal');
          n++;
        }

        s = g(s, _e5);
      } else switch (r) {
        case "string":
          s = i;
          break;

        case "number":
          s = u;
          break;

        case "boolean":
          s = c;
          break;

        case "object":
          s = l;
      }

      var a = [];

      for (; n < t.length; n++) {
        var _r12 = ht(t[n], e);

        a.push(_r12);
      }

      return new it(s, a);
    }
  }]);

  return it;
}();

var lt = /*#__PURE__*/function () {
  function lt(t, e) {
    _classCallCheck(this, lt);

    this.type = t, this.args = e;
  }

  _createClass(lt, [{
    key: "evaluate",
    value: function evaluate(e, r) {
      if (this.type === c) return Boolean(this.args[0].evaluate(e, r));
      if (this.type === i) return m(this.args[0].evaluate(e, r));

      if (this.type === u) {
        var _iterator10 = _createForOfIteratorHelper(this.args),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _t4 = _step10.value;

            var _s8 = Number(_t4.evaluate(e, r));

            if (!isNaN(_s8)) return _s8;
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        return null;
      }

      if (this.type === h) {
        var _iterator11 = _createForOfIteratorHelper(this.args),
            _step11;

        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var _s9 = _step11.value;

            try {
              var _n10 = lt.toColor(_s9.evaluate(e, r));

              if (_n10 instanceof t) return _n10;
            } catch (_unused) {}
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }

        return null;
      }
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      var r = t[0],
          s = lt.types[r];

      if (s === c || s === i) {
        if (2 !== t.length) throw new Error("".concat(r, " expects one argument"));
      } else if (t.length < 2) throw new Error("".concat(r, " expects at least one argument"));

      var n = [];

      for (var _a5 = 1; _a5 < t.length; _a5++) {
        var _r13 = ht(t[_a5], e);

        n.push(_r13);
      }

      return new lt(s, n);
    }
  }, {
    key: "toBoolean",
    value: function toBoolean(t) {
      return Boolean(t);
    }
  }, {
    key: "toString",
    value: function toString(t) {
      return m(t);
    }
  }, {
    key: "toNumber",
    value: function toNumber(t) {
      var e = Number(t);
      if (isNaN(e)) throw new Error("\"".concat(t, "\" is not a number"));
      return e;
    }
  }, {
    key: "toColor",
    value: function toColor(e) {
      if (e instanceof t) return e;

      if ("string" == typeof e) {
        var _r14 = t.fromString(e);

        if (_r14) return _r14;
        throw new Error("\"".concat(e, "\" is not a color"));
      }

      if (Array.isArray(e)) return t.fromArray(e);
      throw new Error("\"".concat(e, "\" is not a color"));
    }
  }]);

  return lt;
}();

lt.types = {
  "to-boolean": c,
  "to-color": h,
  "to-number": u,
  "to-string": i
};

var ut = /*#__PURE__*/function () {
  function ut(t) {
    _classCallCheck(this, ut);

    this.val = t, this.type = f(t);
  }

  _createClass(ut, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return this.val;
    }
  }], [{
    key: "parse",
    value: function parse(t) {
      if (2 !== t.length) throw new Error('"literal" expects 1 argument');
      return new ut(t[1]);
    }
  }]);

  return ut;
}();

var ct = /*#__PURE__*/function () {
  function ct(t) {
    _classCallCheck(this, ct);

    this.arg = t, this.type = i;
  }

  _createClass(ct, [{
    key: "evaluate",
    value: function evaluate(t, e) {
      return p(f(this.arg.evaluate(t, e)));
    }
  }], [{
    key: "parse",
    value: function parse(t, e) {
      if (2 !== t.length) throw new Error('"typeof" expects 1 argument');
      return new ct(ht(t[1], e));
    }
  }]);

  return ct;
}();

function ht(t, e, r) {
  var s = typeof t;

  if ("string" === s || "boolean" === s || "number" === s || null === t) {
    if (r) switch (r.kind) {
      case "string":
        "string" !== s && (t = lt.toString(t));
        break;

      case "number":
        "number" !== s && (t = lt.toNumber(t));
        break;

      case "color":
        t = lt.toColor(t);
    }
    t = ["literal", t];
  }

  if (!Array.isArray(t) || 0 === t.length) throw new Error("Expression must be a non empty array");
  var n = t[0];
  if ("string" != typeof n) throw new Error("First element of expression must be a string");
  var a = pt[n];
  if (void 0 === a) throw new Error("Invalid expression operator \"".concat(n, "\""));
  if (!a) throw new Error("Unimplemented expression operator \"".concat(n, "\""));
  return a.parse(t, e, r);
}

var pt = {
  array: it,
  boolean: it,
  collator: null,
  format: null,
  image: null,
  literal: ut,
  number: it,
  "number-format": null,
  object: it,
  string: it,
  "to-boolean": lt,
  "to-color": lt,
  "to-number": lt,
  "to-string": lt,
  typeof: ct,
  accumulated: null,
  "feature-state": null,
  "geometry-type": b,
  id: v,
  "line-progress": null,
  properties: d,
  at: P,
  get: T,
  has: F,
  in: G,
  "index-of": V,
  length: D,
  slice: H,
  "!": N,
  "!=": M,
  "<": k,
  "<=": A,
  "==": $,
  ">": j,
  ">=": q,
  all: _,
  any: R,
  case: z,
  coalesce: I,
  match: L,
  within: null,
  interpolate: U,
  "interpolate-hcl": U,
  "interpolate-lab": U,
  step: B,
  let: S,
  var: O,
  concat: rt,
  downcase: st,
  "is-supported-script": null,
  "resolved-locale": null,
  upcase: st,
  rgb: nt,
  rgba: at,
  "to-rgba": ot,
  "-": Q,
  "*": W,
  "/": X,
  "%": Y,
  "^": Z,
  "+": tt,
  abs: et,
  acos: et,
  asin: et,
  atan: et,
  ceil: et,
  cos: et,
  e: et,
  floor: et,
  ln: et,
  ln2: et,
  log10: et,
  log2: et,
  max: et,
  min: et,
  pi: et,
  round: et,
  sin: et,
  sqrt: et,
  tan: et,
  zoom: x,
  "heatmap-density": null,
  "has-id": J,
  none: C
};
export { _ as ALL, R as ANY, tt as Add, it as Assert, P as At, et as Calculate, z as Case, I as Coalesce, lt as Coerce, rt as Concat, X as Div, $ as EQ, q as GE, j as GT, b as GeomType, T as Get, F as Has, J as HasID, v as ID, G as In, V as IndexOf, U as Interpolate, A as LE, k as LT, D as Length, S as Let, ut as Literal, L as Match, Y as Mod, W as Mul, M as NE, C as NONE, N as NOT, Z as Pow, d as Properties, nt as Rgb, at as Rgba, H as Slice, B as Step, st as String, Q as Sub, ot as ToRgba, ct as TypeOf, O as Var, x as Zoom, ht as createExpression, pt as ops };